import { api } from './client';

export interface SavedChatResponse {
  id: number;
  bookId?: number | null;
  listId?: number | null;
  content: string;
  prompt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSavedResponseInput {
  content: string;
  prompt?: string;
  book_id?: number;
  list_id?: number;
}

export interface UpdateSavedResponseScopeInput {
  book_id: number | null;
  list_id: number | null;
}

export const listSavedResponsesByBook = (bookId: number): Promise<SavedChatResponse[]> =>
  api.get<SavedChatResponse[]>(`/api/saved-responses?book_id=${bookId}`);

export const listSavedResponsesByList = (listId: number): Promise<SavedChatResponse[]> =>
  api.get<SavedChatResponse[]>(`/api/saved-responses?list_id=${listId}`);

export const listSavedResponsesLibraryWide = (): Promise<SavedChatResponse[]> =>
  api.get<SavedChatResponse[]>('/api/saved-responses?scope=library');

export const listAllSavedResponses = (): Promise<SavedChatResponse[]> =>
  api.get<SavedChatResponse[]>('/api/saved-responses');

export const createSavedResponse = (input: CreateSavedResponseInput): Promise<SavedChatResponse> =>
  api.post<SavedChatResponse>('/api/saved-responses', input);

export const updateSavedResponseScope = (
  id: number,
  input: UpdateSavedResponseScopeInput
): Promise<SavedChatResponse> => api.patch<SavedChatResponse>(`/api/saved-responses/${id}`, input);

export const deleteSavedResponse = (id: number): Promise<void> =>
  api.delete<void>(`/api/saved-responses/${id}`);
